module.exports = __webpack_public_path__ + "static/media/absensi_siswa.608bc64f.png";